var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncreasing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.614,
    height: 22.13,
    viewBox: "0 0 19.614 22.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "increasing",
    transform: "translate(-35.5 504.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M55.363-504.532a3.854,3.854,0,0,0-2.139,1.2,3.892,3.892,0,0,0,1.877,6.4,4.66,4.66,0,0,0,1.953,0,3.888,3.888,0,0,0,2.9-4,3.411,3.411,0,0,0-.347-1.374,4.05,4.05,0,0,0-1.343-1.606,5.034,5.034,0,0,0-1.232-.556A5.252,5.252,0,0,0,55.363-504.532Zm.934,1.1a.526.526,0,0,1,.147.3c.031.182.044.2.258.276.423.16.863.649.863.961a.379.379,0,0,1-.334.369c-.12,0-.213-.084-.485-.422a.736.736,0,0,0-.649-.3c-.458,0-.783.245-.774.6.009.316.231.458.943.614a1.9,1.9,0,0,1,.983.427,1.126,1.126,0,0,1,.4.7,1.186,1.186,0,0,1-.93,1.365c-.245.076-.249.085-.28.271-.044.258-.213.414-.409.378s-.262-.129-.294-.365c-.022-.2-.031-.209-.209-.262a1.4,1.4,0,0,1-1.036-1.143.266.266,0,0,1,.116-.254c.218-.173.454-.085.578.209a.869.869,0,0,0,.907.538c.623,0,.952-.262.845-.667-.071-.253-.28-.374-.934-.534-.8-.2-1.067-.356-1.276-.77a1.257,1.257,0,0,1-.022-1.014,1.509,1.509,0,0,1,.956-.765c.058-.018.076-.071.076-.222s.022-.214.116-.289A.31.31,0,0,1,56.3-503.429Z",
    transform: "translate(-15.949)",
    fill: "#da8c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M57.085-486.752a4.827,4.827,0,0,0-.894.1.347.347,0,0,0-.04.547c.107.1.12.1.765.071l.658-.027-.2.182c-.409.369-1.566,1.325-2.206,1.823a48.651,48.651,0,0,1-8.424,5.284,54.244,54.244,0,0,1-6.071,2.588,3.218,3.218,0,0,0-.609.271.351.351,0,0,0,.245.569,40.682,40.682,0,0,0,4.368-1.668c1.076-.467,3.376-1.6,4.381-2.162a50.1,50.1,0,0,0,8.268-5.729c.325-.285.627-.543.672-.574.071-.053.071-.027,0,.467-.111.7-.107.818.018.939a.355.355,0,0,0,.587-.178c.009-.058.089-.587.178-1.179.165-1.13.16-1.25-.018-1.343A6.455,6.455,0,0,0,57.085-486.752Z",
    transform: "translate(-4.284 -16.979)",
    fill: "#da8c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M396.187-362.915a.565.565,0,0,0-.191.231c-.062.182-.071,12.654-.009,12.818a.707.707,0,0,0,.142.2c.1.089.147.093,1.192.093,1.183,0,1.21-.009,1.334-.253.036-.071.049-1.855.049-6.44,0-6.969.018-6.525-.267-6.671a3.509,3.509,0,0,0-1.121-.067C396.419-363,396.312-362.991,396.187-362.915Z",
    transform: "translate(-344.413 -135.278)",
    fill: "#da8c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M282.187-304.916a.565.565,0,0,0-.191.231c-.062.182-.071,10.074-.009,10.238a.706.706,0,0,0,.142.2c.1.089.147.093,1.183.093,1.2,0,1.25-.013,1.343-.276.036-.093.049-1.695.049-5.159,0-5.515.013-5.2-.267-5.351a3.51,3.51,0,0,0-1.121-.067C282.419-305,282.312-304.991,282.187-304.916Z",
    transform: "translate(-235.484 -190.699)",
    fill: "#da8c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M168.236-239.924c-.24.116-.236.04-.236,3.918,0,2.433.013,3.62.049,3.714.093.262.147.276,1.343.276,1.036,0,1.085,0,1.183-.093a.707.707,0,0,0,.142-.2c.022-.062.04-1.566.04-3.692,0-3.905,0-3.8-.249-3.923A12.927,12.927,0,0,0,168.236-239.924Z",
    transform: "translate(-126.607 -252.83)",
    fill: "#da8c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M54.32-178.813a.429.429,0,0,0-.231.187c-.085.138-.089.236-.089,2.4a21.3,21.3,0,0,0,.049,2.357c.125.245.151.254,1.334.254,1.045,0,1.094,0,1.192-.093a.706.706,0,0,0,.142-.2c.022-.062.04-1.05.04-2.317a9.078,9.078,0,0,0-.08-2.366.371.371,0,0,0-.231-.209A12.11,12.11,0,0,0,54.32-178.813Z",
    transform: "translate(-17.677 -311.233)",
    fill: "#da8c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M35.647-29.871c-.133.12-.147.156-.147.382s.013.262.147.382l.142.129H54.825l.142-.129c.133-.12.147-.156.147-.382s-.013-.262-.147-.382L54.825-30H35.789Z",
    transform: "translate(0 -453.468)",
    fill: "#da8c51"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreasing);
export default __webpack_public_path__ + "static/media/increasing.36e428a7408f885848f07ba9251e79e7.svg";
export { ForwardRef as ReactComponent };